import axios from 'axios';
import React from 'react';
import { withNavigation } from './NavigationWrapper';
import Loader from './loader';


class Course extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      blogData: [],
      courseData: [],
      siteLanguage: ''
    };
  }
  componentDidMount() {
    const BackendUrl = process.env.REACT_APP_BACKEND_API_URL;
    const siteLanguage = localStorage.getItem('siteLanguage') || 'en';
    this.setState.siteLanguage = siteLanguage
    axios
      .post(`${BackendUrl}/course/multiple/1`)
      .then((response) => {
        const data = response.data.data;
        const filteredData = data.slice(-2).map(item => ({
          title: item?.title[siteLanguage] || "Loading Data",
          image: item?.image?.src || "Loading Data",
          class_length_minute: item?.class_length_minute?.[siteLanguage] || item?.class_length_minute?.en,
          duration_in_month: item?.duration_in_month?.[siteLanguage] || item?.duration_in_month?.en,
        }));
        sessionStorage.setItem('courseData', JSON.stringify(filteredData));
        this.setState.courseData = data;
        const blogData = data
          .filter(item => item.title[siteLanguage])
          .map(item => ({
            title: item?.title[siteLanguage] || item?.title.en,
            description: item?.sections[0]?.content[siteLanguage] || item?.sections[0]?.content.en,
            image: item?.image?.src || "Loading Data",
            image_name: item?.image?.name || "Loading Data",
            class_length_minute: item?.class_length_minute?.[siteLanguage] || item?.class_length_minute?.en,
            duration_in_month: item?.duration_in_month?.[siteLanguage] || item?.duration_in_month?.en,
            language: item?.languages?.[siteLanguage] || item?.languages?.en,
            _id: item?._id || "Loading Data",
            sections: item?.sections?.map(section => ({
              content: section?.content?.[siteLanguage] || "Loading Data",
              title: section?.title?.[siteLanguage] || "Loading Data",
            }))
          }));
        this.setState({ blogData, loading: false, })
        
      })
      .catch((error) => {
        console.error("Error fetching countries:", error);
         this.setState({ loading: false });
      });
    }

    handleShowMore = (index) => {
      const selectedPost = this.state.blogData[index];
      if (selectedPost) {
        // const matchingCourses = this.state.courseData.filter(course => course._id === selectedPost._id);
        this.props.navigate(`/our-course/${selectedPost.title}`, { state: { post: selectedPost } });
      } else {
        console.log('No data found for the selected index:', index);
      }
    };

    render() {
      const { loading,blogData } = this.state;

      if (loading) return <Loader />;

    return (
      <div className={`container-fluid py-3 ${this.setState.siteLanguage === 'ur' ? ' direction-rtl' : ''}`}>
        <div className="container">
          <h1 className="display-3 mb-3 ">
           {this.setState.siteLanguage === 'ur' ? 
              <>تازہ ترین <span className="text-primary">ہمارے کورسز</span> سے</> : 
              <>Latest From <span className="text-primary">Our Courses</span></>
            }
          </h1>
          <div className="row g-4 justify-content-center">
            {blogData.map((post, index) => (
              <div className="col-lg-6 col-xl-4" key={index}>
                <div className="blog-item">
                  <div className="blog-img position-relative overflow-hidden">
                    <img src={post.image} className="img-fluid w-100 course-img" alt={post.title} />
                    {/* <div className="bg-primary d-inline px-3 py-2 text-center text-white position-absolute top-0 end-0">
                      {post.duration_in_month}
                    </div> */}
                  </div>
                  <div className=''>
                    <div className="p-4 text-capitalize">
                      <a href={post.link} className="d-inline-block h4 lh-sm mb-3">{post.title}</a>
                      <p className="mb-2">{post.description.length > 300 ? post.description.slice(0, 300) + '...' : post.description}</p>
                      <p className='mb-2'>{post.class_length_minute}</p>
                      <p className='mb-2'>{post.duration_in_month}</p>
                      <p className='mb-2'>{post.language}</p>
                    </div>
                    <div className='p-4'>
                      <button onClick={() => this.handleShowMore(index)} className="btn btn-primary px-3 mt-2">
                      {this.setState.siteLanguage === 'ur' ? 
                          <>مزید تفصیلات</> : 
                          <>More Details</>
                        }
                        </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default withNavigation(Course);
